const createNonProfitOrgSlice = (set, get) => ({
  nonProfitOrg: {
    volunteerOpportunities: [],
    skills: [],
    causes: [],
    volunteerSearchText: '',
    campaigns: [],
    campaignsSearchText: '',
    projects: [],
    projectsSearchText: '',
    donations: [],
    donationsSearchText: '',
  }
});

export default createNonProfitOrgSlice;
